// import ModalForm from "./Form";
import FeesNoticeDetailsTableForm from "./FeesNoticeDetailsTableForm";
import {
	INVOICE_HISTORY,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const FeesNoticeDetailsTableSchema = {
	components: { FeesNoticeDetailsTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: INVOICE_HISTORY + "/" + this.invoiceRequestId + "/fee-notice-details",
			tableId: "fees-notice-details-table",
			formId: "fees-notice-details-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Class Name",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						return value.course_name;
					},
				},
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name;
					},
				},
                {
					title: "UOM",
					type: "custom-html",
					key: "uom_id",
					modifier: (value) => {
						return value.name;
					},
				},
                {
					title: "Quantity",
					type: "text",
					key: "qty",
				},
                {
					title: "Unit Price",
					type: "custom-html",
					key: "price",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
                {
					title: "Charges",
					type: "custom-html",
					key: "debit",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
                {
					title: "Credits",
					type: "custom-html",
					key: "credit",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
                {
					title: "Balance",
					type: "custom-html",
					key: "balance",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "FeesNoticeDetailsTable",
				url: INVOICE_HISTORY + "/" + this.invoiceRequestId + "/fee-notice-details",
				showHeader: true,
				enableHighlights: false,
				enableSaveFilter: false,
				enableRowSelect: false,
				columns: [],
				actions: [
                    {
                        title: this.$t("view"),
                        icon: "eye",
                        type: "none",
                        // component: "app-add-modal",
                        component: "fees-notice-details-table-form",
                        modalId: "fees-notice-details-table-form",
                    },
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "fees-notice-details-table-form",
						modalId: "fees-notice-details-table-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: false,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat('id-ID', {
				style: 'currency',
				currency: 'IDR',
				minimumFractionDigits: 0
			}).format(value);
		}
	},
};
